import { DonutChart } from '@src/entities/ActionPath/ui/components/charts/Donut';
import { Table } from '@src/entities/ActionPath/ui/components/charts/Donut/components/Table';
import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { Widget } from '@src/shared/ui/components/Widget';
import { Divider } from '@uhg-abyss/web/ui/Divider';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { Text } from '@uhg-abyss/web/ui/Text';
import { isEmpty, orderBy, sumBy } from 'lodash';
import React, { useEffect, useState } from 'react';

import { Styles } from './includes/styles';

/**
 * Widget: ActionTakenCodes
 *
 * Displays information about entity action path statuses.
 *
 * @param actionTakenCounts
 * @returns {Element}
 * @constructor
 */
export function ActionTakenCodes({ actionTakenCounts = [] }) {
  const [theData, setTheData] = useState({});
  const [noData, setNoData] = useState(false);

  /**
   * prepare data for display in the chart and the table
   */
  useEffect(() => {
    if (!isEmpty(actionTakenCounts)) {
      const labels = [];
      const data = [];

      actionTakenCounts?.forEach((item) => {
        labels.push(item?.actionTakenName);

        data.push({
          amount: item?.count,
          percent: item?.perc,
          type: item?.actionTakenName,
        });
      });

      labels.sort((a, b) => {
        return a.localeCompare(b);
      });

      setTheData({ data: orderBy(data, ['type'], ['asc']), labels });
    }
  }, [actionTakenCounts]);

  /**
   * Check if there is no data to display
   */
  useEffect(() => {
    if (isEmpty(theData?.data) || (!isEmpty(theData?.data) && sumBy(theData?.data, 'amount') === 0)) {
      setNoData(true);
    } else {
      setNoData(false);
    }
  }, [theData?.data]);

  return (
    <ErrorHandler location="src/widgets/ActionPaths/ActionTakenCodes/ActionTakenCodes.jsx">
      <Widget description="Percentage by taken codes" title="Action Taken Codes">
        <Styles>
          {noData ? (
            <Layout.Stack alignLayout="center">
              <div>
                <IconSymbol color="$gray3" icon="bid_landscape_disabled" size="96" />
              </div>
              <div>
                <Text color="$gray4" fontWeight="bold">
                  Data Not Available
                </Text>
              </div>
            </Layout.Stack>
          ) : (
            <DonutChart data={theData?.data} labels={theData?.labels} />
          )}{' '}
          <Divider />
          <Table data={theData?.data} labels={theData?.labels} />
        </Styles>
      </Widget>
    </ErrorHandler>
  );
}
